export function addplaceholderTextToPostAlert() {
    const postAlertInputs = document.querySelectorAll<HTMLInputElement>('.edit-post-alert__email');
    
    postAlertInputs.forEach((input) => {
        if (input.placeholder === "") {
            input.placeholder = "{{js.PostAlertList.PostAlertEmailPlaceholder}}";
        }
    });
}